<template>
  <div class="container">
    <CreateStepHeader :tmzId="this.$route.params.tmzId"/>
    <p class="step-name">Создание неликвидного отчета</p>
    <div class="dropzone">
      <input type="file" class="input-field" ref="file" @change="sendFile">
      <div v-if="!uploading" class="call-to-action">
        Перенесите файл сюда
        <div role="button">Выбрать файл с компьютера</div>
      </div>
      <div v-if="uploading" class="progress-bar">
        <progress class="progress" :value="uploadProgress" max="100">
          {{ uploadProgress }} %
        </progress>
      </div>
    </div>
    <div class="download-btn-container">
      <a :href="downloadUrl" download>
        <button class="download-btn" type="button">
          Скачать шаблон
        </button>
      </a>
    </div>
    <modal name="file-modal">
      <div class="modal-inner">
        <div>
          Следует загружать следующие типы файлов: xlsx, xls
        </div>
        <button @click="closeModal">Понятно</button>
      </div>
    </modal>
  </div>
</template>

<script>
import CreateStepHeader from "@/components/tmz/CreateStepHeader";
import { mapGetters } from 'vuex'
export default {
  name: "CreateIlliquidReportThree",
  data(){
    return {
      downloadUrl: `${process.env.VUE_APP_MEDIA_URL}/media/Не_ликвидный.xlsx`,
      uploading: false,
      progress: 0
    }
  },
  components:{
    CreateStepHeader
  },
  computed: {
    ...mapGetters([
      'uploadProgress'
    ])
  },
  methods: {
    submitFile() {
      const file = document.querySelector("#file"),
          defaultDiv = document.querySelector(".default"),
          successDiv = document.querySelector(".success"),
          parentStateElement = successDiv.parentElement,
          greenBackground = "#36B300";

      let fileName = file.value,
          idxDot = fileName.lastIndexOf(".") + 1,
          extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
      if (!(extFile == "xlsx" || extFile == "xls" || extFile == "xlsm")) {
        alert("Следует загружать следующие типы файлов: xlsx, xls");
        file.value = "";
      } else {
        defaultDiv.style.display = "none";
        successDiv.style.display = "inline-block";
        parentStateElement.style.backgroundColor = greenBackground;

        this.file = this.$refs.file.files[0];

        let formData = new FormData();
        if (this.file) {
          formData.append("file", this.file);
          formData.append("tmz_id", this.$route.params.tmzId);
          // formData.append("type", "liquid_unclaimed");
          this.$store.dispatch("importIlliquidTmzExcelThree", formData);
        }
      }
    },
    async sendFile() {
      const file = this.$refs.file.files[0]
      let fileName = document.querySelector('.input-field').value,
        idxDot = fileName.lastIndexOf(".") + 1,
        extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
      const formData = new FormData()
      formData.append('file', file)
      formData.append("tmz_id", this.$route.params.tmzId);


      if (!(extFile == "xlsx" || extFile == "xls" || extFile == "xlsm")) {
        this.$modal.show("file-modal")
        this.file = null
      } else {
        try {
          this.uploading = true;
          this.$store.dispatch("importIlliquidTmzExcelThree", formData);
        } catch (e) {
          console.log(e);
        }
      }

    },
    closeModal() {
      this.$modal.hide("file-modal");
    }
  }
}
</script>

<style scoped>
.step-name {
  text-align: center;
}

.download-btn-container {
  display: flex;
  justify-content: flex-end;
  padding: 2rem;
}

.download-btn {
  padding: 1rem 2rem;
  border: none;
  outline: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 1.1rem;
  background: #36429e;
  color: white;
}

.dropzone {
  margin-top: 3rem;
  height: 250px;
  min-height: 250px;
  padding: 10px;
  position: relative;
  cursor: pointer;
  border: 5px dashed #dddddd;
  outline-offset: 10px;
  background: lightcyan;
  color: dimgray;
}

.input-field {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
}

.dropzone:hover {
  background: lightblue;
  transition: all 300ms ease;
}

.dropzone .call-to-action {
  font-size: 1.5rem;
  text-align: center;
  padding: 70px 0;
}

.call-to-action > div {
  font-size: 1rem;
  padding: 1rem 2rem;
  background: #00d1b2;
  max-width: 300px;
  margin: 1rem auto;
  border-radius: 20px;
  color: #fff;
}

.progress-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: inherit;
  /*min-height: 200px;*/
  /*width: 100%;*/
  /*text-align: center;*/

}

progress {
  border-radius: 7px;
  width: 90%;
  height: 22px;
  color: black;
  /*box-shadow: 1px 1px 4px rgba( 0, 0, 0, 0.2 );*/
}
progress::-webkit-progress-bar {
  background-color: #ededed;
  border-radius: 7px;
}
progress::-webkit-progress-value {
  background-color: #00d1b2;
  border-radius: 7px;
  /*box-shadow: 1px 1px 5px 3px rgba( 255, 0, 0, 0.8 );*/
}
progress::-moz-progress-bar {
  /* style rules */
}
</style>